/**
 * @fileoverview Prompt template for portrait-image-creator-fal-v2.
 *
 * This is a simple passthrough template that just uses the image prompt directly.
 * The image prompt is typically generated by portrait-prompt-creator-v2.
 */

export const prompt = `{{{imagePrompt}}}`;
